import { baseIsEqual } from './base'
export default function isEqual(value, other) {
  return baseIsEqual(value, other)
}
